
import { Injectable, inject } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class TelemetryService {
  private logger = inject(LoggerService);
  private eventQueue: Array<{ event: string; properties?: Record<string, unknown> }> = [];

  trackEvent(eventName: string, properties: Record<string, any> = {}) {
    const event = {
      event: eventName,
      properties,
      timestamp: new Date().toISOString()
    };
    
    this.eventQueue.push(event);
    this.logger.log('Telemetry Event Tracked:', eventName, properties);
    
    // Simulate flushing to server
    this.flush();
  }

  private flush() {
    if (this.eventQueue.length > 0) {
      // In a real app, this would post to an API
      // this.http.post('/api/metrics', this.eventQueue).subscribe();
      this.eventQueue = [];
    }
  }
}
